// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();




$(document).ready(function() {
	
	$(".service-tab-nav .nav-link:first").addClass('active');
	$(".service-panel:first").addClass('show active');
	
	$(".home-what-we-do-content ul").addClass('fa-ul');
	$(".home-what-we-do-content li").prepend('<span class="fa-li"><i class="fas fa-circle-check"></i></span>');
	
	$('.navbar-toggler').click(function () {
		$(this).toggleClass('is-active');
		$('body').toggleClass('mobile-nav-active');
	});	
    
	$('.quotes-wrapper').slick({
		slide: '.quote-item',
		rows: 0,
		speed: 1500,
		autoplay: true,
		autoplaySpeed: 4500,
		pauseOnHover: false,
		dots: true,
		arrows: true,
		draggable: true,
		slidesToScroll: 1,
		mobileFirst: true,
		prevArrow : '.quotes-slide-prev',
		nextArrow : '.quotes-slide-next',
		responsive: [
		    {
		      breakpoint: 992,
		      settings: {
		        slidesToShow: 2
		      }
		    },

		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1
		      }
		    }
		  ]

		
	});
	
});
	
